import { Attr, BelongsTo, Model } from "spraypaint";

import type InstagramHandle from "shared/resources/InstagramHandle";
import type OrganisationSocialIntegration from "shared/resources/OrganisationSocialIntegration";
import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class InstagramHandlesOrganisationSocialIntegration extends ApplicationRecord {
  static jsonapiType = "instagram_handles_organisation_social_integrations";

  @Attr({ persist: false }) archivedAt: string;

  @Attr({ persist: false }) createdAt: string;

  @BelongsTo() instagramHandle: InstagramHandle;

  @BelongsTo() organisationSocialIntegration: OrganisationSocialIntegration;

  @Attr({ persist: false }) updatedAt: string;
}

export default InstagramHandlesOrganisationSocialIntegration;
